/**
 * ============================================================================
 * อัตราค่าธรรมเนียมการศึกษา — หน้า /Tuitionfee
 * ============================================================================
 * ข้อมูลค่าเทอมมาจาก POST admission2017/student/Tuitionfee โดยส่ง { type, fac }
 * หน้า Tuitionfees โหลดทีละคณะ (cache ไว้) ไม่ยิงทุกคณะพร้อมกันตอนเปิดหน้า
 * ไฟล์นี้เก็บ 2 อย่างที่เดิมกระจายอยู่ใน JSX ของหน้า
 *
 *   1) FEE_SECTIONS  = ภาค/ศูนย์ และคณะที่เปิดในแต่ละภาค (เดิมคือ <Pane> 20 ก้อน)
 *   2) FEE_FORMULAS  = ตัวเลขส่วนต่างค่าธรรมเนียม (เดิม hardcode ปนใน JSX
 *                      เช่น +2200, +22000, 26000, +2000, +10000, 246100)
 *
 * เปิด/ปิดคณะ หรือปรับส่วนต่างของปีถัดไป แก้ที่ไฟล์นี้ที่เดียว
 * ============================================================================
 */

/**
 * สูตรคิดช่วงราคาของแต่ละระดับการศึกษา
 *
 * practiceFeeMax       ค่าเทอมบวกเพิ่มได้สูงสุดเท่าไร (ตามรายวิชาปฏิบัติที่ลงทะเบียน)
 * allCourseExtra       ส่วนต่างของประมาณการค่าใช้จ่ายตลอดหลักสูตร
 * allCourseAddsEntryFee  true = ประมาณการตลอดหลักสูตรรวมค่าธรรมเนียมแรกเข้าด้วย
 * allCourseMax         กำหนดเพดานตลอดหลักสูตรเป็นตัวเลขตรง ๆ (ถ้าใส่ จะไม่ใช้ allCourseExtra)
 * rangeNote            คำอธิบายว่าทำไมราคาเป็นช่วง (null = ราคาเดียว ไม่ต้องอธิบาย)
 */
export const FEE_FORMULAS = {
  /** ปริญญาตรี ทุกภาค/ทุกศูนย์ */
  bachelor: {
    practiceFeeMax: 2200,
    allCourseExtra: 22000,
    rangeNote:
      "ค่าเทอมของระดับปริญญาตรีขึ้นกับจำนวนรายวิชาปฏิบัติที่ลงทะเบียนในภาคเรียนนั้น สูงสุดเพิ่มได้ 2,200 บาท",
  },

  /** ปริญญาโท — ค่าเทอมเหมาจ่ายราคาเดียว */
  master: {},

  /** ปริญญาโท คณะวิทยาศาสตร์และเทคโนโลยี — มีค่าวิชาปฏิบัติเพิ่ม */
  masterScience: {
    practiceFeeMax: 2000,
    allCourseExtra: 10000,
    allCourseAddsEntryFee: true,
    rangeNote:
      "ค่าเทอมขึ้นกับรายวิชาที่ลงทะเบียนในภาคเรียนนั้น สูงสุดเพิ่มได้ 2,000 บาท",
  },

  /** ปริญญาเอก */
  doctor: {
    allCourseMax: 246100,
  },
};

/**
 * ภาค/ศูนย์ และคณะที่เปิดรับ
 * formula ระบุที่ระดับ section ได้ และ override รายคณะได้ (ป.โท วิทยาศาสตร์)
 */
export const FEE_SECTIONS = [
  {
    key: "normal-kpp",
    label: "ภาคปกติ (กำแพงเพชร)",
    type: "1",
    formula: "bachelor",
    faculties: [
      { fac: "2", name: "คณะครุศาสตร์" },
      { fac: "1", name: "คณะวิทยาศาสตร์และเทคโนโลยี" },
      { fac: "3", name: "คณะมนุษยศาสตร์และสังคมศาสตร์" },
      { fac: "4", name: "คณะวิทยาการจัดการ" },
      { fac: "5", name: "คณะเทคโนโลยีอุตสาหกรรม" },
      { fac: "8", name: "คณะพยาบาลศาสตร์" },
    ],
  },
  {
    key: "normal-maesot",
    label: "ภาคปกติ (แม่สอด)",
    type: "5",
    formula: "bachelor",
    faculties: [
      { fac: "3", name: "คณะมนุษยศาสตร์และสังคมศาสตร์" },
      { fac: "4", name: "คณะวิทยาการจัดการ" },
      { fac: "5", name: "คณะเทคโนโลยีอุตสาหกรรม" },
    ],
  },
  {
    key: "weekend-kpp",
    label: "ภาค กศ.บป. (กำแพงเพชร)",
    type: "2",
    formula: "bachelor",
    faculties: [
      { fac: "3", name: "คณะมนุษยศาสตร์และสังคมศาสตร์" },
      { fac: "4", name: "คณะวิทยาการจัดการ" },
      { fac: "5", name: "คณะเทคโนโลยีอุตสาหกรรม" },
    ],
  },
  {
    key: "weekend-maesot",
    label: "ภาค กศ.บป. (แม่สอด)",
    type: "3",
    formula: "bachelor",
    faculties: [
      { fac: "3", name: "คณะมนุษยศาสตร์และสังคมศาสตร์" },
      { fac: "4", name: "คณะวิทยาการจัดการ" },
      { fac: "5", name: "คณะเทคโนโลยีอุตสาหกรรม" },
    ],
  },
  {
    key: "master",
    label: "ปริญญาโท",
    type: "4",
    formula: "master",
    faculties: [
      { fac: "2", name: "คณะครุศาสตร์" },
      { fac: "1", name: "คณะวิทยาศาสตร์และเทคโนโลยี", formula: "masterScience" },
      { fac: "3", name: "คณะมนุษยศาสตร์และสังคมศาสตร์" },
      { fac: "4", name: "คณะวิทยาการจัดการ" },
    ],
  },
  {
    key: "doctor",
    label: "ปริญญาเอก",
    type: "7",
    formula: "doctor",
    faculties: [{ fac: "2", name: "คณะครุศาสตร์" }],
  },
];

function toInt(value) {
  const number = parseInt(value, 10);
  return Number.isFinite(number) ? number : 0;
}

/**
 * แปลง 1 แถวจาก API ให้เป็นตัวเลขที่พร้อมแสดง
 *
 * termFee    ค่าธรรมเนียมการศึกษาต่อภาคเรียน
 * entryFee   ค่าธรรมเนียมแรกเข้า จ่ายครั้งเดียวตอนเข้าเรียน (field amout)
 * firstTerm  ยอดที่ต้องจ่ายจริงในภาคเรียนแรก = ค่าเทอม + ค่าธรรมเนียมแรกเข้า
 * allCourse  ประมาณการค่าใช้จ่ายตลอดหลักสูตร
 */
export function buildFeeRow(item, formulaKey) {
  const formula = FEE_FORMULAS[formulaKey] || FEE_FORMULAS.master;
  const term = toInt(item.term_fees);
  const entry = toInt(item.amout);
  const spread = formula.practiceFeeMax || 0;

  const allMin =
    toInt(item.all_term_fees) + (formula.allCourseAddsEntryFee ? entry : 0);
  const allMax =
    formula.allCourseMax != null
      ? formula.allCourseMax
      : allMin + (formula.allCourseExtra || 0);

  return {
    major: item.major_name,
    termFee: { min: term, max: term + spread },
    entryFee: entry,
    entryParts: [
      { label: "คู่มือนักศึกษา", amount: toInt(item.manual_fees) },
      { label: "ลงทะเบียนนักศึกษาใหม่", amount: toInt(item.news_std_fees) },
      { label: "ทำบัตรนักศึกษา", amount: toInt(item.std_card) },
      { label: "ประกันของเสียหาย", amount: toInt(item.garantee) },
    ].filter((part) => part.amount > 0),
    firstTerm: { min: term + entry, max: term + entry + spread },
    allCourse: { min: allMin, max: allMax },
    rangeNote: formula.rangeNote || null,
  };
}
